import { render, staticRenderFns } from "./VoucherNaoPago.vue?vue&type=template&id=0283af2c&scoped=true"
import script from "./VoucherNaoPago.vue?vue&type=script&lang=js"
export * from "./VoucherNaoPago.vue?vue&type=script&lang=js"
import style0 from "./VoucherNaoPago.vue?vue&type=style&index=0&id=0283af2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283af2c",
  null
  
)

export default component.exports